import React, { useEffect, useState } from 'react';
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(s => {
        if (s <= 1) return initialSeconds;
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [initialSeconds]);
  const hh = String(Math.floor(seconds / 3600)).padStart(2, '0');
  const mm = String(Math.floor(seconds % 3600 / 60)).padStart(2, '0');
  const ss = String(seconds % 60).padStart(2, '0');
  return {
    hh,
    mm,
    ss
  };
}
export function UrgencySection() {
  const {
    hh,
    mm,
    ss
  } = useCountdown(10 * 3600 + 16 * 60 + 13);
  return <section className="bg-gradient-to-br from-green-900 to-green-800 py-16 sm:py-20" data-id="element-631">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center flex flex-col items-center gap-8" data-id="element-632">
        {/* Headline */}
        <div data-id="element-633">
          <div className="inline-flex items-center gap-2 bg-red-500 text-white text-xs font-bold px-3 py-1.5 rounded-full mb-4 uppercase tracking-wide" data-id="element-634">
            ⚡ Oferta por Tiempo Limitado — Precios Suben Pronto
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight" data-id="element-635">
            No Esperes Más —<br data-id="element-636" />
            <span className="text-green-400" data-id="element-637">El Stock Se Agota Rápido</span>
          </h2>
          <p className="text-green-300 mt-3 text-base" data-id="element-638">
            El 78% de nuestras clientas eligen el pack de 3 cajas para
            resultados óptimos y duraderos.
          </p>
        </div>

        {/* Countdown HH:MM:SS */}
        <div className="flex flex-col items-center gap-3" data-id="element-639">
          <p className="text-green-300 text-sm font-medium uppercase tracking-widest" data-id="element-640">
            La oferta termina en
          </p>
          <div className="flex items-center gap-2 sm:gap-3" data-id="element-641">
            <div className="flex flex-col items-center" data-id="element-642">
              <div className="bg-green-950 border border-green-700 rounded-xl px-4 sm:px-5 py-3 min-w-[60px] sm:min-w-[72px]" data-id="element-643">
                <span className="text-3xl sm:text-5xl font-bold text-green-400 tabular-nums" data-id="element-644">
                  {hh}
                </span>
              </div>
              <span className="text-green-400 text-xs mt-1.5 font-medium uppercase tracking-wide" data-id="element-645">
                Horas
              </span>
            </div>
            <span className="text-green-400 text-3xl sm:text-4xl font-bold -mt-4" data-id="element-646">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-647">
              <div className="bg-green-950 border border-green-700 rounded-xl px-4 sm:px-5 py-3 min-w-[60px] sm:min-w-[72px]" data-id="element-648">
                <span className="text-3xl sm:text-5xl font-bold text-green-400 tabular-nums" data-id="element-649">
                  {mm}
                </span>
              </div>
              <span className="text-green-400 text-xs mt-1.5 font-medium uppercase tracking-wide" data-id="element-650">
                Min
              </span>
            </div>
            <span className="text-green-400 text-3xl sm:text-4xl font-bold -mt-4" data-id="element-651">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-652">
              <div className="bg-green-950 border border-green-700 rounded-xl px-4 sm:px-5 py-3 min-w-[60px] sm:min-w-[72px]" data-id="element-653">
                <span className="text-3xl sm:text-5xl font-bold text-green-400 tabular-nums" data-id="element-654">
                  {ss}
                </span>
              </div>
              <span className="text-green-400 text-xs mt-1.5 font-medium uppercase tracking-wide" data-id="element-655">
                Seg
              </span>
            </div>
          </div>
        </div>

        {/* Stock bar */}
        <div className="w-full max-w-md" data-id="element-656">
          <div className="flex items-center justify-between mb-2" data-id="element-657">
            <span className="text-white text-sm font-semibold" data-id="element-658">
              ⚠️ Solo quedan 23 unidades
            </span>
            <span className="text-red-400 text-sm font-bold" data-id="element-659">15% restante</span>
          </div>
          <div className="w-full bg-green-950 rounded-full h-3 border border-green-700" data-id="element-660">
            <div className="bg-red-500 h-3 rounded-full" style={{
            width: '15%'
          }} data-id="element-661"></div>
          </div>
          <p className="text-green-400 text-xs mt-2 text-center" data-id="element-662">
            🔴 127 personas están viendo este producto ahora mismo
          </p>
        </div>

        {/* Per-day framing */}
        <div className="bg-green-950 border border-green-700 rounded-2xl px-6 py-4 w-full max-w-md" data-id="element-663">
          <p className="text-green-300 text-sm text-center" data-id="element-664">
            El pack más popular sale a solo{' '}
            <span className="text-white font-bold text-lg" data-id="element-665">1,33€/día</span> —
            menos que un café ☕
          </p>
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center gap-3 w-full max-w-md" data-id="element-666">
          <a href="#pricing" className="w-full bg-green-600 hover:bg-green-700 text-white font-bold text-lg px-8 py-4 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl tracking-wide text-center" data-id="element-667">
            ASEGURAR MI PEDIDO AHORA →
          </a>
          <p className="text-green-400 text-xs font-medium" data-id="element-668">
            Envío inmediato · Stock muy limitado
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-sm text-green-300" data-id="element-669">
            <span data-id="element-670">✅ Envío Gratis</span>
            <span data-id="element-671">·</span>
            <span data-id="element-672">✅ Garantía 90 Días</span>
            <span data-id="element-673">·</span>
            <span data-id="element-674">✅ Pago Seguro</span>
          </div>
        </div>
      </div>
    </section>;
}